import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ConfirmModal from '../ui/ConfirmModal';
import { apiJson } from '../../_helpers/api';

function api(path, opts) {
  return apiJson('/endpoint/admin' + path, opts);
}

const TYPE_LABEL = { buyer_agent: "Buyer's agent", showing_agent: 'Showing agent', both: 'Both' };

export function LicenseQueue() {
  const [users, setUsers] = useState(null);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);
  const [rejecting, setRejecting] = useState(null);

  const load = () => api('/licenses/pending').then(res => {
    if (res.status === 'success') setUsers(res.users);
    else setError(res.message || 'Could not load the queue.');
  }).catch(() => setError('Could not load the queue.'));

  useEffect(() => { load(); }, []);

  const act = (id, action, body) => {
    setBusy(id);
    api(`/licenses/${id}/${action}`, { method: 'POST', body }).then(() => {
      setBusy(null);
      load();
    }).catch(() => setBusy(null));
  };

  return (
    <>
      <p className="sh-page-sub">Check each license against the issuing state's registry, then verify or reject.</p>

      {error ? <div className="sh-error" style={{ marginBottom: 18 }}>{error}</div> : null}

      {users === null ? (
        <div className="sh-empty">Loading…</div>
      ) : users.length === 0 ? (
        <div className="sh-empty">
          <div className="big">✅</div>
          <b>Queue is clear.</b>
          <p>New submissions land here the moment agents finish onboarding.</p>
        </div>
      ) : (
        <div className="sh-list">
          {users.map(u => (
            <div className="sh-job" key={u._id}>
              <div>
                <div className="sh-job-title">{u.name || '(no name)'} <span style={{ fontWeight: 400, color: 'var(--ng-muted)' }}>· {TYPE_LABEL[u.type] || u.type}</span></div>
                <div className="sh-job-meta">
                  <span>✉️ {u.email}</span>
                  {u.phone_number ? <span>📞 {u.phone_number}</span> : null}
                </div>
                <div className="sh-job-meta" style={{ marginTop: 6 }}>
                  <span><b>License:</b> {u.license && u.license.number} ({u.license && u.license.state})</span>
                  {u.license && u.license.brokerage ? <span><b>Brokerage:</b> {u.license.brokerage}</span> : null}
                  {u.license && u.license.expires ? <span><b>Expires:</b> {new Date(u.license.expires).toLocaleDateString()}</span> : null}
                  {u.coverage && u.coverage.cities && u.coverage.cities.length ? <span><b>Covers:</b> {u.coverage.cities.join(', ')} ({u.coverage.radius_miles || 25} mi)</span> : null}
                </div>
              </div>
              <div className="sh-job-side">
                <button className="sh-btn sh-btn-green" disabled={busy === u._id} onClick={() => act(u._id, 'verify')}>Verify</button>
                <button className="sh-btn sh-btn-danger-ghost" disabled={busy === u._id} onClick={() => setRejecting(u)}>Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {rejecting ? (
        <ConfirmModal
          title={'Reject ' + (rejecting.name || 'this agent') + "'s license?"}
          message="They'll be emailed your reason and can correct and resubmit from their profile."
          confirmLabel="Reject license"
          danger
          withReason
          reasonRequired
          reasonLabel="Reason (sent to the agent)"
          defaultReason="The license number could not be matched to the state registry."
          onConfirm={reason => { act(rejecting._id, 'reject', { reason }); setRejecting(null); }}
          onClose={() => setRejecting(null)}
        />
      ) : null}
    </>
  );
}

// legacy route: /admin/licenses → the console's licenses tab
export default function AdminLicenses() {
  return <Redirect to="/admin?tab=licenses" />;
}
